(() => {
  const DAY = 86400000;
  const estimate = (data, currency, now = Date.now()) => {
    const date = Date.parse(`${data.date}T00:00:00Z`);
    const age = now - date;
    const base = Number(data.baseJPY);
    const yen = Number(data.rates?.JPY);
    const target = Number(data.rates?.[currency]);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(data.date || '') || !Number.isFinite(date)
      || new Date(date).toISOString().slice(0, 10) !== data.date
      || age < 0 || age >= 7 * DAY
      || !Number.isFinite(base) || base <= 0
      || !Number.isFinite(yen) || yen <= 0
      || !Number.isFinite(target) || target <= 0
      || !/^[A-Z]{3}$/.test(currency)) return null;
    const amount = base / yen * target;
    return Number.isFinite(amount) ? amount : null;
  };

  class RoomCurrencyEstimate extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.selector = this.querySelector('select');
      this.controls = this.querySelector('[data-currency-controls]');
      this.output = this.querySelector('output');
      this.fallback = this.querySelector('[data-currency-fallback]');
      try {
        this.data = JSON.parse(this.querySelector('[data-currency-rates]').textContent);
        if (!this.selector || !this.controls || !this.output || !this.fallback) throw new Error('Incomplete component');
        this.selector.addEventListener('change', () => this.update(), { signal: this.controller.signal });
        this.update();
        this.timer = setInterval(() => this.update(), 60000);
      } catch {
        if (this.controls) this.controls.hidden = true;
        if (this.fallback) this.fallback.hidden = false;
      }
    }

    update() {
      const amount = estimate(this.data, this.selector.value);
      if (amount === null) {
        this.output.textContent = '';
        this.controls.hidden = true;
        this.fallback.hidden = false;
        return;
      }
      try {
        const formatted = new Intl.NumberFormat(this.dataset.locale === 'ja' ? 'ja-JP' : 'en', {
          style: 'currency', currency: this.selector.value, currencyDisplay: 'code',
          minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(Math.round(amount));
        const next = `≈ ${formatted}`;
        if (this.output.textContent !== next) this.output.textContent = next;
        this.controls.hidden = false;
        this.fallback.hidden = true;
      } catch {
        this.output.textContent = '';
        this.controls.hidden = true;
        this.fallback.hidden = false;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('room-currency-estimate')) {
    customElements.define('room-currency-estimate', RoomCurrencyEstimate);
  }
})();
